"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Jodit = _interopRequireDefault(require("../Jodit")); // import app components


var Wysiwyg = function Wysiwyg(props) {
  var value = props.value,
      onChange = props.onChange;

  var handleChange = function handleChange(c) {
    return onChange(c);
  };

  return /*#__PURE__*/_react.default.createElement(_Jodit.default, {
    onChange: handleChange,
    defaultValue: value
  });
};

var _default = Wysiwyg;
exports.default = _default;